module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/manage/change-password/change-password.component.css
// module id = ./src/app/components/manage/change-password/change-password.component.css
// module chunks = main